export const SET_TIME_ZONE = 'SET_TIME_ZONE';
export const setTimeZoneGlobal = timeZone => ({
  type: SET_TIME_ZONE,
  payload: timeZone
});